export default "__VITE_ASSET__b800f86d__"